var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolboxPagesGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.73 59.7602V124.86C146.73 125.938 146.303 126.972 145.542 127.735C144.78 128.498 143.748 128.928 142.67 128.93H84.6701C83.5923 128.925 82.5601 128.494 81.798 127.732C81.0358 126.97 80.6054 125.938 80.6001 124.86V49.4802C80.6054 48.4033 81.0362 47.3722 81.7986 46.6116C82.561 45.8511 83.5932 45.4228 84.6701 45.4202H133L146.73 59.7602Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.71 132.5L136.49 135.03C136.396 136.104 135.88 137.096 135.055 137.79C134.23 138.484 133.164 138.822 132.09 138.73L74.3402 133.67C73.2666 133.576 72.2741 133.06 71.5805 132.235C70.8868 131.41 70.5487 130.344 70.6402 129.27L77.2102 54.1802",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.91 59.7701H133.25V44.1101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1899 70.26H135.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1899 78.51H135.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1899 86.6802H126.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1899 104.86H135.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1899 113.02H126.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6699 45.06C92.6699 44.6923 92.7424 44.3282 92.8831 43.9885C93.0238 43.6488 93.23 43.3401 93.49 43.0801C93.75 42.8201 94.0587 42.6139 94.3984 42.4731C94.7381 42.3324 95.1022 42.26 95.4699 42.26C95.8376 42.26 96.2017 42.3324 96.5414 42.4731C96.8811 42.6139 97.1898 42.8201 97.4498 43.0801C97.7098 43.3401 97.9161 43.6488 98.0568 43.9885C98.1975 44.3282 98.2699 44.6923 98.2699 45.06V55.83C98.2699 56.0139 98.2337 56.1959 98.1634 56.3658C98.093 56.5356 97.9899 56.69 97.8599 56.82C97.7299 56.95 97.5755 57.0531 97.4057 57.1234C97.2358 57.1938 97.0538 57.23 96.8699 57.23C96.6861 57.23 96.504 57.1938 96.3342 57.1234C96.1643 57.0531 96.01 56.95 95.88 56.82C95.75 56.69 95.6468 56.5356 95.5765 56.3658C95.5061 56.1959 95.4699 56.0139 95.4699 55.83V55.83V48.83",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9399 109.36H13.8099C12.1204 109.36 10.4996 108.691 9.30208 107.499C8.10458 106.307 7.42785 104.69 7.41992 103V64.8801",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22021 64.5901V41.2201C4.22021 39.5227 4.8945 37.8948 6.09473 36.6946C7.29496 35.4944 8.92283 34.8201 10.6202 34.8201H120.71C122.408 34.8201 124.035 35.4944 125.236 36.6946C126.436 37.8948 127.11 39.5227 127.11 41.2201",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.53 58.48H30.09C29.4991 58.48 29.02 58.959 29.02 59.55V69.62C29.02 70.2109 29.4991 70.69 30.09 70.69H32.53C33.121 70.69 33.6 70.2109 33.6 69.62V59.55C33.6 58.959 33.121 58.48 32.53 58.48Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0903 34.4601V21.3201C45.089 20.8286 45.1849 20.3417 45.3723 19.8873C45.5598 19.4329 45.8353 19.0201 46.1828 18.6726C46.5304 18.325 46.9432 18.0496 47.3976 17.8621C47.8519 17.6746 48.3388 17.5788 48.8303 17.5801H82.5003C83.4923 17.5801 84.4435 17.9741 85.1449 18.6755C85.8463 19.3769 86.2403 20.3282 86.2403 21.3201V34.4601",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1402 31.5702V24.4202C80.1402 24.223 80.0625 24.0337 79.924 23.8933C79.7856 23.753 79.5974 23.6728 79.4002 23.6702H51.9302C51.7321 23.6728 51.5428 23.7526 51.4027 23.8927C51.2626 24.0328 51.1828 24.2221 51.1802 24.4202V31.5702",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 65.23H70.6202",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolboxPagesGrey);
export default __webpack_public_path__ + "static/media/toolbox_pages_grey.195c888dca32092c9867366b929d18b0.svg";
export { ForwardRef as ReactComponent };